import { AbstractCoroutine2jzyhqo91sb0o as AbstractCoroutine } from '../AbstractCoroutine.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { JobCancellationException2g3wpni5v5fkt as JobCancellationException } from '../Exceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  close$defaultlxi0kykibhye as close$default,
  ReceiveChannel24wu5e2tj9lbp as ReceiveChannel,
  SendChannel38sllbxw662ws as SendChannel,
} from './Channel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ChannelCoroutineClass;
function ChannelCoroutine() {
  if (ChannelCoroutineClass === VOID) {
    class $ extends AbstractCoroutine() {
      constructor(parentContext, _channel, initParentJob, active) {
        super(parentContext, initParentJob, active);
        this.d1c_1 = _channel;
      }
      mx(cause) {
        if (this.zw())
          return Unit_instance;
        var tmp;
        if (cause == null) {
          // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
          tmp = JobCancellationException().b15(null == null ? this.gw() : null, null, this);
        } else {
          tmp = cause;
        }
        this.ox(tmp);
      }
      q1b(cause, $super) {
        return this.nx(cause, ($super == null ? true : $super instanceof ChannelCoroutine()) ? $super : THROW_CCE());
      }
      ox(cause) {
        var exception = this.ex(cause);
        this.d1c_1.mx(exception);
        this.rx(exception);
      }
      v1a() {
        return this.d1c_1.v1a();
      }
      *c1b(element, $completion) {
        yield* this.d1c_1.c1b(element, $completion);
        return Unit_instance;
      }
      d1b(element) {
        return this.d1c_1.d1b(element);
      }
      m1b(cause) {
        return this.d1c_1.m1b(cause);
      }
      r1b(handler) {
        this.d1c_1.r1b(handler);
      }
      *f1b($completion) {
        return yield* this.d1c_1.f1b($completion);
      }
      p1() {
        return this.d1c_1.p1();
      }
    }
    protoOf($).o1b = close$default;
    initMetadataForClass($, 'ChannelCoroutine', VOID, VOID, [ReceiveChannel(), SendChannel()], [1, 0]);
    ChannelCoroutineClass = $;
  }
  return ChannelCoroutineClass;
}
//region block: exports
export {
  ChannelCoroutine as ChannelCoroutine12l2gxei4u780,
};
//endregion

//# sourceMappingURL=ChannelCoroutine.mjs.map
